import React from "react";
import { Input, Select, Typography } from "antd";
import { Search } from "lucide-react";
import { InventoryStatusCode } from "~/utils/constants";
import { RESPONSIVE_CLASSES } from "~/utils/responsive";

const { Title } = Typography;
const { Option } = Select;

interface InventoryFiltersProps {
  filterStatus: InventoryStatusCode | "all";
  setFilterStatus: (status: InventoryStatusCode | "all") => void;
  searchTerm?: string;
  setSearchTerm?: (term: string) => void;
  setPage: (page: number) => void;
}

const InventoryFilters: React.FC<InventoryFiltersProps> = ({
  filterStatus,
  setFilterStatus,
  searchTerm = "",
  setSearchTerm = () => {},
  setPage,
}) => {
  return (
    <div
      className={`flex lg:flex-col sm:flex-row lg:justify-start lg:items-start sm:justify-between sm:items-center gap-2 sm:gap-4 mb-4 sm:mb-6 space-y-3 sm:space-y-0`}
    >
      <Title level={2} className={`!mb-0 ${RESPONSIVE_CLASSES.titleText} font-serif font-bold text-neutral-900 flex-1`}>
        Inventory
      </Title>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 flex-wrap">
        <div className="relative">
          <Input
            prefix={<Search size={16} className="text-neutral-400" />}
            placeholder="Search inventory..."
            className="w-full sm:w-64 lg:w-50"
            allowClear
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1);
            }}
            size="middle"
          />
        </div>
        <Select
          value={filterStatus}
          onChange={(value) => {
            setFilterStatus(value);
            setPage(1);
          }}
          className="w-full sm:w-48"
          size="middle"
        >
          <Option value="all">All Status</Option>
          <Option value={InventoryStatusCode.AVAILABLE_LIVE}>
            Available - Live
          </Option>
          <Option value={InventoryStatusCode.AVAILABLE_ON_HAND}>
            Available - On Hand
          </Option>
          <Option value={InventoryStatusCode.NO_POSSESSION}>
            No AHC Possession
          </Option>
          <Option value={InventoryStatusCode.RELEASED}>Released</Option>
        </Select>
      </div>
    </div>
  );
};

export default InventoryFilters;
